import React from 'react'
import PropTypes from 'prop-types'

import { ContentModal, Flex, Caption, Title, P, Button } from 'ui/acro'

import ModalImage from './ModalImage'
import { survey_skipped_event, survey_started_event } from 'gtm/pushEvents'
import { callAll } from 'utils'

const SurveyOutOfDate = ({ useModal, acknowledgeAlert }) => {
  const handleAccept = () => {
    acknowledgeAlert(() => {
      window.location.href = '/surveys/onboarding?start=true'
    })
  }

  return (
    <ContentModal
      useModal={useModal}
      overflow='hidden' // Handles border-radius for image
    >
      <Flex flexDirection={['column', null, 'row']}>
        {/* Image */}
        <ModalImage />

        {/* Content */}
        <Flex
          width={['100%', null, '50%']}
          flexDirection='column'
          justifyContent='center'
          px={['28px', null, '48px']}
        >
          <Caption mt={['18px', null, '0px']} mb='8px'>
            Unlock improved recommendations
          </Caption>

          <Title mb={['4px', null, '8px']} wordBreak='break-word'>
            A Smarter, More Personalized Experience
          </Title>

          <P mb={['16px', null, '28px']}>
            Take 1 minute to update your preferences and enjoy new and improved
            daily recommendations picked just for you.
          </P>

          <Flex flexDirection='column'>
            <Button
              onClick={callAll(handleAccept, survey_started_event)}
              variant='primary'
              width='100%'
              mb='16px'
              id='survey_retake'
              aria-label='Retake Survey'
            >
              Update
            </Button>

            <Button
              onClick={callAll(useModal.close, survey_skipped_event)}
              variant='secondary'
              width='100%'
              mb={['32px', null, '0px']}
              id='survey_skip'
              aria-label='Skip For Now'
            >
              Maybe later
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </ContentModal>
  )
}

SurveyOutOfDate.propTypes = {
  useModal: PropTypes.object.isRequired,
  acknowledgeAlert: PropTypes.func.isRequired
}

export default SurveyOutOfDate
